import { FC } from 'react';

import { SearchSuggestionClickHandler } from '../../model';
import { ButtonSuggestionItem } from './ButtonSuggestionItem';
import { ButtonSuggestionWrapper } from './ButtonSuggestions.styles';
import { ButtonSuggestionItemProps } from './model';

type Props = {
    items: ButtonSuggestionItemProps[];
    onClick?: SearchSuggestionClickHandler;
};
export const ButtonSuggestions: FC<Props> = ({ items, onClick }) => {
    if (!items?.length) {
        return null;
    }

    return (
        <ButtonSuggestionWrapper>
            {items.map((item, index) => (
                <ButtonSuggestionItem
                    key={index}
                    keyword={item.keyword}
                    url={item.url}
                    onClick={(event) => onClick?.(event, { suggestion: item.keyword, queryKey: item.queryKey })}
                />
            ))}
        </ButtonSuggestionWrapper>
    );
};
